import { app } from '../../../app';
import { Controller } from './google-marketplace-login.controller';

app.component('googleMarketplaceLogin', {
    bindings: {domain: '<'},
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-login/google-marketplace-login.component.js